// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".policy[data-v-7c41c4f6]{width:98%;padding-left:2vw}.loadingView[data-v-7c41c4f6]{text-align:center;position:relative}", ""]);
// Exports
module.exports = exports;
